import layout from '@/components/common/layout';
import employeeList from '../views/employee/list';
import employeeCreate from '../views/employee/create';
import empcontractList from '../views/employee/list-contract';
import empretirementList from '../views/employee/list-retirement';

export default [
    {
        path: '/employee',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "员工列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'employee_list',// 子选项
                    }
                },
                component: employeeList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增员工",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'employee_list',// 子选项
                    }
                },
                component: employeeCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑员工",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'employee_list',// 子选项
                    }
                },
                component: employeeCreate,
            },
            {
                path: 'list-contract',
                meta: {
                    metaInfo: {
                        title: "合同提醒",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'employee_list_contract',// 子选项
                    }
                },
                component: empcontractList,
            },
            {
                path: 'list-retirement',
                meta: {
                    metaInfo: {
                        title: "退休提醒",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '11',// 父选项
                        child: 'employee_list_retirement',// 子选项
                    }
                },
                component: empretirementList,
            },
        ]
    },
];
